import { analyticsApiClient } from "@ikea-customer-self-serve/analytics-api-client";

const analytics = analyticsApiClient("store-events");

export default analytics;
